export default "__VITE_ASSET__y1N57EYx__"